import { useI18n } from 'vue-i18n'

export const MOVEMENT_TRANSFER_TYPES = () => {
	const { t } = useI18n()

	return [
		{
			id: 0,
			text: t('accounts.balancesAndMovements.movementAll')
		},
		{
			id: 1,
			text: t('accounts.balancesAndMovements.movementDebit')
		},
		{
			id: 2,
			text: t('accounts.balancesAndMovements.movementCredit')
		}
	]
}
